/*Search brands on brands page*/
$(document).ready(function () {
  var inputSearchBrandsDesktop = $(".brands-form-desktop .brands-input");
  var inputSearchBrandsMobile = $(".brands-form-mobile .brands-input");
  var clearButtonSearchBrandsDesktop = $(".brands-form-desktop .icon-close");
  var clearButtonSearchBrandsMobile = $(".brands-form-mobile .icon-close");
  var formTextSearchBrandsDesktop = $(".brands-form-desktop .brands-form-text");
  var formTextSearchBrandsMobile = $(".brands-form-mobile .brands-form-text");

  // Функция для обновления видимости элементов в зависимости от значения в поле ввода
  function updateBrandsVisibility(input, brandsCol, formText) {
    var value = input.val().toLowerCase();
    var count = 0;
    brandsCol.each(function () {
      var colVisible = false;
      $(this).find(".brands-category").each(function () {
        var categoryVisible = false;
        $(this)
          .find(".brands-item")
          .each(function () {
            var text = $(this).text().toLowerCase();
            var match = text.indexOf(value) > -1;
            if (match) {
              var regex = new RegExp(value, "gi");
              var replacedText = text.replace(regex, "<mark>$&</mark>");
              $(this).html(replacedText);
              categoryVisible = true;
              count++;
              $(this).removeClass("hidden"); // Удаляем класс 'hidden', чтобы показать элемент
            } else {
              $(this).html(text);
              $(this).addClass("hidden"); // Добавляем класс 'hidden', чтобы скрыть элемент
            }
          });
        if (categoryVisible) {
          $(this).removeClass("hidden"); // Удаляем класс 'hidden', чтобы показать категорию
          colVisible = true;
        } else {
          $(this).addClass("hidden"); // Добавляем класс 'hidden', чтобы скрыть категорию
        }
      });
      if (colVisible) {
        $(this).removeClass("hidden"); // Удаляем класс 'hidden', чтобы показать столбец
      } else {
        $(this).addClass("hidden"); // Добавляем класс 'hidden', чтобы скрыть столбец
      }
    });
    if (count == 0) {
      formText.removeClass("hidden");
    } else {
      formText.addClass("hidden");
    }
  }

  // что делать при вводе текста в input
  function inputSearchBrandsKeyup(input, clearBtn, brandsCol, formText) {
    updateBrandsVisibility(input, brandsCol, formText);
    if (input.val().length > 0) {
      clearBtn.show();
    } else {
      clearBtn.hide();
    }
  }

  // Функция очистки input
  function clearSearchBrandsInput(input, clearBtn, brandsCol, formText) {
    input.val("");
    updateBrandsVisibility(input, brandsCol, formText);
    clearBtn.hide();
  }

  // Слушатель событий для поля ввода на десктопе и таблетке
  inputSearchBrandsDesktop.on("keyup", function () {
    inputSearchBrandsKeyup(inputSearchBrandsDesktop, clearButtonSearchBrandsDesktop, $('.brands-col-desktop'), formTextSearchBrandsDesktop);
  });

  // Слушатель событий для поля ввода на мобилке
  inputSearchBrandsMobile.on("keyup", function () {
    inputSearchBrandsKeyup(inputSearchBrandsMobile, clearButtonSearchBrandsMobile, $('.brands-col-mobile'), formTextSearchBrandsMobile);
  });

  // Слушатель событий для кнопки очистить на десктопе и таблетке
  clearButtonSearchBrandsDesktop.on("click", function () {
    clearSearchBrandsInput(inputSearchBrandsDesktop, clearButtonSearchBrandsDesktop, $('.brands-col-desktop'), formTextSearchBrandsDesktop);
  });

  // Слушатель событий для кнопки очистить на мобилке
  clearButtonSearchBrandsMobile.on("click", function () {
    clearSearchBrandsInput(inputSearchBrandsMobile, clearButtonSearchBrandsMobile, $('.brands-col-mobile'), formTextSearchBrandsMobile);
  });
});
